import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Button } from '@material-ui/core';
import CreateIcon from '@material-ui/icons/Create';
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import HomeIcon from '@material-ui/icons/Home';
import ScheduleIcon from '@material-ui/icons/Schedule';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import OrderStatusModal from '../orderStatusModal/orderStatusModal';
import DeleteOrderModal from '../deleteOrderModal/deleteOrderModal';
import paymentActions from '../../actions/payment/payment';
import config from '../../config';

import './ordersList.less';

class OrdersList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      changingStatusOrder: null,
      deletingOrder: null,
    };
  }

  openStatusModal = changingStatusOrder => {
    this.setState({ changingStatusOrder });
  }

  closeStatusModal = () => {
    this.setState({ changingStatusOrder: null });
  }

  openDeleteModal = deletingOrder => {
    this.setState({ deletingOrder });
  }

  closeDeleteModal = () => {
    this.setState({ deletingOrder: null });
  }

  payForTheOrder = async (orderId) => {
    const paywallUrl = await paymentActions.createPaymentUrl(orderId);
    window.location = paywallUrl;
  }

  shouldDisplayPaymentButton = (paymentType, paymentStatus) => {
    const { adminMode } = this.props;

    return !adminMode
      && paymentType === config.paymentMethodVerbose.online
      && (
        paymentStatus === config.paymentStatusVerbose.newPayment
        || paymentStatus === config.paymentStatusVerbose.failedPayment
      );
  }
  /* eslint-disable */
  render() {
    const {
      orders, changeOrderStatus, deleteOrder, adminMode,
    } = this.props;
    const { changingStatusOrder, deletingOrder } = this.state;

    return (
      <div>
        {adminMode && (
          <OrderStatusModal
            open={!!changingStatusOrder}
            orderId={changingStatusOrder && changingStatusOrder.id}
            closeModal={this.closeStatusModal}
            onStatusChange={changeOrderStatus}
          />
        )}

        {adminMode && (
          <DeleteOrderModal
            open={!!deletingOrder}
            orderId={deletingOrder && deletingOrder.id}
            onOk={deleteOrder}
            closeModal={this.closeDeleteModal}
          />
        )}

        <Paper className="paper-box order-list">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <div className="orders-list-table-header">
                    Id
                  </div>
                </TableCell>
                <TableCell align="left">
                  <div className="orders-list-table-header">
                    <ScheduleIcon />
                    Data złożenia
                  </div>
                </TableCell>
                {adminMode && (
                  <TableCell>
                    <div className="orders-list-table-header">
                      <AlternateEmailIcon />
                        E-mail
                    </div>
                  </TableCell>
                )}
                <TableCell align="left">
                  <div className="orders-list-table-header">
                    <ShoppingCartIcon />
                      Produkty
                  </div>
                </TableCell>
                <TableCell align="left">
                  <div className="orders-list-table-header">
                    <ShoppingCartIcon />
                      Uwagi
                  </div>
                </TableCell>
                <TableCell align="left">
                  <div className="orders-list-table-header">
                    <ScheduleIcon />
                      Data dostawy
                  </div>
                </TableCell>
                <TableCell align="left">
                  <div className="orders-list-table-header">
                    <HomeIcon />
                      Adres
                  </div>
                </TableCell>
                <TableCell align="left">
                  <div className="orders-list-table-header">
                    <LocalShippingIcon />
                      Status
                  </div>
                </TableCell>
                <TableCell align="left">
                  <div className="orders-list-table-header">
                    Płatność
                    (Typ / Status)
                  </div>
                </TableCell>
                {adminMode && <TableCell />}
              </TableRow>
            </TableHead>
            <TableBody>
              {orders.map(row => (
                <TableRow key={row.id}>
                  <TableCell component="th" scope="row">
                    {row.id}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {moment(row.createDate.replace('Z', ''), 'DD-MM-YYYYTHH:mm:ss').format('DD/MM/YYYY HH:mm')}
                  </TableCell>
                  {adminMode && (
                    <TableCell component="th" scope="row">
                      {row.buyerName}
                    </TableCell>
                  )}
                  <TableCell align="left">
                    <ul>
                      {row.products.map(product => (
                        <li key={product.productName}>
                          {product.quantity}
                            &nbsp;x&nbsp;
                          {product.productName}
                        </li>
                      ))}
                    </ul>
                  </TableCell>
                  <TableCell align="left">
                    {row.note}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {moment(row.orderDate.replace('Z', ''), 'DD-MM-YYYYTHH:mm:ss').format('DD/MM/YYYY HH:mm')}
                  </TableCell>
                  <TableCell>
                    <div>
                      {row.address.name}
                    </div>
                    <div>
                      {row.address.street}
                    </div>
                    <div>
                      {row.address.postCode}
                      {' '}
                      {row.address.city}
                    </div>
                    {!!row.address.nip && (
                      <div>
                        NIP:
                        {' '}
                        {row.address.nip}
                      </div>
                    )}
                    <div>
                      Tel:
                      {' '}
                      {row.address.phoneNumber}
                    </div>
                  </TableCell>
                  <TableCell align="left">
                    {row.status}
                    {adminMode && (
                      <IconButton onClick={() => this.openStatusModal(row)}>
                        <CreateIcon />
                      </IconButton>
                    )}
                  </TableCell>
                  <TableCell align="left">
                    {row.paymentType}
                    {' / '}
                    {row.paymentStatus}
                    {this.shouldDisplayPaymentButton(row.paymentType, row.paymentStatus) && (
                      <div className="pay-button-wrapper">
                        <Button variant="contained" onClick={() => this.payForTheOrder(row.id)}>
                          Zapłać
                        </Button>
                      </div>
                    )}
                  </TableCell>
                  {adminMode && (
                    <TableCell>
                      <IconButton onClick={() => this.openDeleteModal(row)}>
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </div>
    );
  }
  /* eslint-enable */
}

OrdersList.propTypes = {
  orders: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      products: PropTypes.arrayOf(
        PropTypes.shape({
          quantity: PropTypes.number,
          name: PropTypes.string,
        }),
      ),
      address: PropTypes.shape({
        name: PropTypes.string,
        street: PropTypes.string,
        postCode: PropTypes.string,
        city: PropTypes.string,
        nip: PropTypes.string,
      }),
    }),
  ).isRequired,
  changeOrderStatus: PropTypes.func,
  deleteOrder: PropTypes.func,
  adminMode: PropTypes.bool,
};

OrdersList.defaultProps = {
  adminMode: true,
  changeOrderStatus: () => {},
  deleteOrder: () => {},
};

export default OrdersList;
